import { atom } from 'jotai'
import { AnyToken } from 'src/common/types/models/Tokens'

export const withdrawnNFTsAtom = atom<AnyToken[]>([])

export const viccCountAtom = atom<number>(0)
